var map = {
	"./404.svg": 671,
	"./arror-expand.svg": 318,
	"./arrow-down-black.svg": 672,
	"./arrow-down-blue.svg": 673,
	"./arrow-down-grey.svg": 674,
	"./arrow-left-black.svg": 675,
	"./arrow-right-white.png": 676,
	"./arrow-right.svg": 677,
	"./big_unicorn.png": 678,
	"./blocto.svg": 679,
	"./blocto_new.svg": 249,
	"./blt-logo.png": 200,
	"./blt-logo.svg": 680,
	"./blue-loader.svg": 681,
	"./bsc-logo.svg": 319,
	"./circle-grey.svg": 682,
	"./circle.svg": 683,
	"./coinbaseWalletIcon.svg": 684,
	"./dropdown-blue.svg": 685,
	"./dropdown.svg": 686,
	"./dropup-blue.svg": 687,
	"./error-red.svg": 688,
	"./ethereum-logo.svg": 320,
	"./flow-logo.svg": 321,
	"./fortmaticIcon.png": 689,
	"./fusd-logo.png": 690,
	"./help-icon.svg": 322,
	"./ido-congrat.svg": 323,
	"./link.svg": 691,
	"./loader.svg": 154,
	"./logo-blocto-swap.svg": 692,
	"./magnifying-glass.svg": 693,
	"./maintain.svg": 694,
	"./menu.svg": 695,
	"./metamask.png": 317,
	"./moxy.png": 696,
	"./no-transfer.svg": 697,
	"./noise.png": 698,
	"./octopus.svg": 324,
	"./plus-black.svg": 699,
	"./plus-blue.svg": 700,
	"./plus-grey.svg": 701,
	"./plus-white.svg": 702,
	"./portisIcon.png": 703,
	"./question-mark.svg": 704,
	"./question.svg": 705,
	"./revv.png": 706,
	"./shuffle.png": 325,
	"./solana-logo.svg": 707,
	"./spinner.svg": 708,
	"./sportium-logo.png": 709,
	"./starly-logo.jpeg": 710,
	"./stepCheck.svg": 201,
	"./stepCheckLight.svg": 202,
	"./stepFail.svg": 203,
	"./stepFailLight.svg": 204,
	"./success-blue.svg": 711,
	"./tUSDT.png": 712,
	"./token-list/lists-dark.png": 713,
	"./token-list/lists-light.png": 714,
	"./token-logo.png": 715,
	"./trustWallet.png": 716,
	"./tusdt-logo.svg": 326,
	"./usdc.png": 717,
	"./usdt.png": 327,
	"./walletConnectIcon.svg": 718,
	"./x.svg": 719,
	"./xl_uni.png": 720
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 284;